import React from 'react';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';
export function EmailSignatureSameh() {
  return <div className="max-w-3xl mx-auto p-8" data-id="element-215">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-216">
        <table cellPadding="0" cellSpacing="0" border={0} style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        borderCollapse: 'collapse'
      }} data-id="element-217">
          <tbody data-id="element-218">
            <tr data-id="element-219">
              <td style={{
              paddingRight: '32px',
              verticalAlign: 'middle',
              borderRight: '2px solid #1e293b',
              width: '140px'
            }} data-id="element-220">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxtonoDTZefwd495z2JgnJ/LOGO_ET_SLOGAN_%281%29.jpg" alt="IPcom Logo" style={{
                width: '140px',
                height: 'auto',
                display: 'block'
              }} data-id="element-221" />
              </td>
              <td style={{
              paddingLeft: '32px',
              verticalAlign: 'middle'
            }} data-id="element-222">
                <table cellPadding="0" cellSpacing="0" border={0} style={{
                borderCollapse: 'collapse'
              }} data-id="element-223">
                  <tbody data-id="element-224">
                    <tr data-id="element-225">
                      <td style={{
                      paddingBottom: '10px'
                    }} data-id="element-226">
                        <div style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#0f172a',
                        marginBottom: '2px',
                        letterSpacing: '-0.01em',
                        lineHeight: '1.2'
                      }} data-id="element-227">
                          Sameh BOUKADIDA
                        </div>
                        <div style={{
                        fontSize: '15px',
                        color: '#475569',
                        fontWeight: '500',
                        lineHeight: '1.3'
                      }} data-id="element-228">
                          Conductrice travaux, IPcom
                        </div>
                      </td>
                    </tr>
                    <tr data-id="element-229">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-230">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-231">
                          Tél :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-232">
                          +33 (1) 47 90 08 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-233">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-234">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-235">
                          Email :{' '}
                        </span>
                        <a href="mailto:s.boukadida@ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-236">
                          s.boukadida@ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-237">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-238">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-239">
                          Web :{' '}
                        </span>
                        <a href="https://www.ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-240">
                          ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-241">
                      <td style={{
                      paddingTop: '8px'
                    }} data-id="element-242">
                        <div style={{
                        fontSize: '13px',
                        color: '#64748b',
                        lineHeight: '1.4',
                        fontWeight: '400'
                      }} data-id="element-243">
                          17, Avenue des Louvresses, bât B2
                          <br data-id="element-244" />
                          92230 Gennevilliers, France
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}